import { type ReactNode, useState } from "react";
import EtudiantHeader from "./headers/EtudiantHeader";
import DashboardFooter from "./DashboardFooter";
import { useNavigate } from "react-router-dom";

// Composant de mise en page spécifique pour le dashboard Étudiant
function EtudiantDashboardLayout({ children }: { children: ReactNode }) {
  const [showAiTooltip, setShowAiTooltip] = useState(false);
  const [showVideoTooltip, setShowVideoTooltip] = useState(false);
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col min-h-screen">
      <div className="sticky top-0 z-50">
        <EtudiantHeader />
      </div>
      <main className="flex-grow">{children}</main>
      <DashboardFooter />
      
      {/* Boutons flottants */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        {/* Bouton IA */}
        <div className="relative">
          <button 
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-colors"
            aria-label="Intelligence Artificielle"
            onMouseEnter={() => setShowAiTooltip(true)}
            onMouseLeave={() => setShowAiTooltip(false)}
            onClick={() => navigate('/etudiant/guide-intelligence')}
          >
            <span className="font-bold text-xl">AI</span>
          </button>
          
          {showAiTooltip && (
            <div className="absolute bottom-16 right-0 bg-white text-gray-800 px-3 py-2 rounded shadow-md text-sm whitespace-nowrap">
              Assistant Intelligence Artificielle
            </div>
          )}
        </div>
        
        {/* Bouton Vidéo */}
        <div className="relative">
          <button 
            className="bg-green-600 hover:bg-green-700 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-colors"
            aria-label="Cinépro"
            onMouseEnter={() => setShowVideoTooltip(true)}
            onMouseLeave={() => setShowVideoTooltip(false)}
            onClick={() => navigate('/etudiant/cinepro')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </button>
          
          {showVideoTooltip && (
            <div className="absolute bottom-16 right-0 bg-white text-gray-800 px-3 py-2 rounded shadow-md text-sm whitespace-nowrap">
              Cinépro
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EtudiantDashboardLayout;
